import Carousel from './components/Carousel.js';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Cookies from './components/Cookies.js';
import SearchBlogPosts from './components/SearchBlogPosts.js';
import SearchFaqQuestions from './components/SearchFaqQuestions.js';
import ZohoForm from './components/ZohoForm.js';
import Accordeon from './components/Accordeon.js';
import Lenis from './components/Lenis.js';
import Scrolly from './components/Scrolly.js';
import Tabs from './components/Tabs.js';
import ProgressBar from './components/ProgressBar.js';
import Modal from './components/Modal.js';
import Counter from './components/Counter.js';
import Gallery from './components/Gallery.js';
import Lightbox from './components/Lightbox.js';
import Ytb from './components/Ytb.js';


export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      header: Header,
      footer: Footer,
      Header,
      Footer,
      Carousel,
      Accordeon,
      counter: Counter,
      Counter,
      gallery: Gallery,
      Gallery,
      Cookies,
      SearchBlogPosts,
      SearchFaqQuestions,
      ZohoForm,
      Lenis,
      Scrolly,
      scrolly: Scrolly,
      lightbox: Lightbox,
      Lightbox,
      ytb: Ytb,
      Ytb,
      youtube: Ytb,
      Youtube: Ytb,
      modal: Modal,
      Modal,
      tabs: Tabs,
      Tabs,
      progressBar: ProgressBar,
      ProgressBar,
      'progress-bar': ProgressBar,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      }
    }
  }
}
